import React, { FC, useMemo } from 'react';

import DropdownSelect, { DropdownSelectProps } from '@/components/fields/DropdownSelect';
import { useIndustries } from '@/hooks/useIndustries';

type IndustryDropdownSelectProps = Omit<DropdownSelectProps, 'options'>;

const IndustryDropdownSelect: FC<IndustryDropdownSelectProps> = props => {
  const { industriesOptions } = useIndustries();

  const options = useMemo(() => industriesOptions.map(({ id, label }) => ({ value: id, label })), [industriesOptions]);

  return <DropdownSelect {...props} options={options} />;
};

export default IndustryDropdownSelect;
